import { TableCols } from "../interfaces/static-data";
import { capitalize } from "./static-data.utils";

export const DISTRIBUTOR_GROUPS: TableCols[] = [
    {
        key: 'name',
        displayValue: 'Name',
    },
    {
        key: 'status',
        displayValue: 'Status',
        valueGetter: (value: any) => capitalize(value?.data?.status?.toLowerCase() || '-'),
        filterValueGetter: ({ data }) => data?.status
    },
    {
        key: 'salesContactId',
        displayValue: 'Sales',
        valueGetter: (value: any) => value?.data?.salesContactId?.name || '-',
        format: (value: any) => value?.salesContactId?.name || '-',
        filterValueGetter: ({ data }) => data?.salesContactId?.name
    },
    {
        key: 'comments',
        displayValue: 'Comments',
    },
    {
        key: 'workflowStatus',
        displayValue: 'Workflow Status',
    },
    {
      key: 'workflowStatus',
      displayValue: 'Workflow Status',
      hideOnForm: true
    },
    {
      key: 'lastUpdatedBy',
      displayValue: 'Last Updated By',
      hideOnForm: true
    },
    {
      key: 'updatedOn',
      displayValue: 'Updated On',
      hideOnForm: true
    },
    {
      key: 'deletedAt',
      displayValue: 'Deleted On',
      hideOnForm: true
    },
];
